import { useState, useEffect, useCallback } from 'react';
import { fetchWithAuth } from './authHelpers'; // Assuming you have a similar helper

export const useFantasyTeams = (userId, eventId, seasonId) => {
  const [fantasyTeams, setFantasyTeams] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchFantasyTeams = useCallback(async () => {
    if (!userId || userId === 'null') {
      setFantasyTeams(null);
      setLoading(false);
      setError('Invalid user ID');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      let url = '';
      if (eventId) {
        url = `${process.env.REACT_APP_BACKEND_URL}/fantasyteam/user/${userId}/event/${eventId}`;
      } else if (seasonId) {
        url = `${process.env.REACT_APP_BACKEND_URL}/fantasyteam/user/${userId}/season/${seasonId}`;
      } else {
        url = `${process.env.REACT_APP_BACKEND_URL}/fantasyteam/user/${userId}`;
      }

      const response = await fetchWithAuth(url, 'GET');

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to fetch fantasy team');
      }

      const data = await response.json();
      setFantasyTeams(data);
    } catch (err) {
      console.error(`Error fetching fantasy team`);
      setError(err.message);
      setFantasyTeams(null);
    } finally {
      setLoading(false);
    }
  }, [userId, eventId, seasonId]);

  useEffect(() => {
    if (userId) {
      fetchFantasyTeams();
    }
  }, [userId, eventId, seasonId, fetchFantasyTeams]);

  return { fantasyTeams, loading, error, refetch: fetchFantasyTeams };
};

export default useFantasyTeams;